import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/term_basic_validation/`, data);
};

const get = async (id) => {
  return await httpClient.get(`/term_basic_validation/${id}`);
};

const getAllByValidation = async (validation_id, tipo_persona) => {
  return await httpClient.get(
    `/term_basic_validation/documents/?filter[document_validation]=${validation_id}&filter[tipo_persona]=${tipo_persona}`,
  );
};

const put = async (id, data) => {
  return await httpClient.put(`/term_basic_validation/${id}/`, data);
};

const patch = async (id, data) => {
  return await httpClient.patch(`/term_basic_validation/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/term_basic_validation/${id}`);
};

export { post, get, getAllByValidation, put, patch, remove };
